export enum CALENDAR_USER_ACTIONS {
  ARROW_CLICK = 'click',
  FINGER_SWIPE = 'swipe',
}
